(ns basic-components.attachments
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.actions.attachment :as attachment-actions]
   [frontend.logging :as logging]
   [frontend.utils :as fu]
   [potpuri.core :refer [fn-> fn->>]]
   [ui.components.alert.view :as alert]))

(defn attachment-view
  [attachment]
  (let [{:keys [attachment/filename db/id]} attachment]
    [:div.email-attachment
     [:div.email-attachment__left
      [:i.fal.fa-paperclip]
      [:span.email-attachment__filename
       filename]]
     [:div.email-attachment__right
      [fu/tooltip-overlay
       {:id        "download-attachment-tooltip"
        :placement "top"}
       (loc/tr :download)
       [:span.email-attachment-download.clickable
        {:on-click (fn [e]
                     (fu/open-attachment! id))}
        [:i.fal.fa-download]]]]]))

(defn add-indicator!
  [state token name size]
  (swap! state update :uploading (fnil conj []) {:token token :name name :size size}))

(defn remove-indicator!
  [state token]
  (swap! state update :uploading (fn->> (remove (fn-> :token (= token))) vec)))

(defn show-indicator-error!
  [state identifier e]
  (let [updater (fn [indicators]
                  (->> indicators
                       (map (fn [{:keys [token] :as indicator}]
                              (if (= token identifier)
                                (assoc indicator :error (loc/tr :attachment-indicator-error))
                                indicator)))
                       vec))]
    (logging/error "Error in uploading attachment" e)
    (swap! state update :uploading updater)))

(defn indicator-view
  [state {:keys [name token error]}]
  (let [error? (not (cu/blank-value? error))]
    [:div
     {:class-name (fu/cs "attachment-listing__indicator"
                         (when error?
                           "attachment-listing__indicator--error"))}
     [:span.attachment-listing__filename
      name]
     (if-not error?
       [:span.attachment-listing__spinner-wrapper
        [:img.attachment-listing__spinner
         {:src "/img/spinner.svg"}]
        (loc/tr :loading-indicator)]
       [:span.attachment-listing__indicator--error
        error])
     (when error?
       [:span.attachment-listing__remove.clickable
        {:on-click (fn [e]
                     (remove-indicator! state token))}
        [:i.fal.fa-trash]])]))

(defn attachment-view-with-remove
  [attachment entity-id on-remove!]
  (let [{:keys [attachment/filename db/id]} attachment]
    [:div.attachment-listing__indicator
     [:span.attachment-listing__filename.clickable
      {:on-click #(fu/open-attachment! id)}
      filename]
     [:span.attachment-listing__remove.clickable
      {:on-click (fn [e]
                   (attachment-actions/*<-remove-attachment
                    {:target-id     entity-id
                     :attachment-id id}
                    (fn []
                      (when (fn? on-remove!)
                        (on-remove! attachment)))
                    (fn [err]
                      (logging/log "failed to remove attachment:" err))))}
      [:i.fal.fa-trash]]]))

(defn attachments-error
  [state]
  (let [error (:error @state)]
    [:div.attachment-error
     (when error
       [alert/danger
        {:on-close    #(swap! state dissoc :error)}
        error])]))

(defn view
  [attachments class-name]
  [:div
   {:class-name (fu/cs (when class-name
                         class-name))}
   (doall
    (for [attachment attachments]
      ^{:key (str "email-attachment-" (:db/id attachment))}
      [attachment-view attachment]))])
